﻿<template>
  <button
    class="button text-center"
    @click="popupWin(UrlParmater, TitleParameter, WidthParameter, HeightParameter)"
    v-html="ButtonLabel"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PopupWindow',
  components: {},
  props: {
    url: {
      type: String,
      default() {
        return null;
      }
    },
    title: {
      type: String,
      default() {
        return null;
      }
    },
    width: {
      type: Number,
      default() {
        return null;
      }
    },
    height: {
      type: Number,
      default() {
        return null;
      }
    },
    buttonLabel: {
      type: String,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      UrlParmater: this.url as string,
      TitleParameter: this.title as string,
      WidthParameter: this.width as number,
      HeightParameter: this.height as number,
      ButtonLabel: this.buttonLabel as string
    };
  },
  methods: {
    popupWin(url: string, title: string, height: number, width: number) {
      let y = window.outerHeight / 2 + window.screenY - height / 2;
      let x = window.outerWidth / 2 + window.screenX - width / 2;
      let features = `toolbar=no, location=no,
             directories=no,
             status=no,
             menubar=no,
             scrollbars=no,
             resizable=no,
             copyhistory=no,
             width=${width},
             height=${height},
             top=${y},
             left=${x}`;
      let wref = window.open(url, title, features);
      let pollTimer = window.setInterval(() => {
        if (wref != null && wref.closed !== false) {
          window.clearInterval(pollTimer);
          this.$emit('popup-closed');
        }
      }, 200);
    }
  }
});
</script>
